const whitespace = "_35sw9gtw3a";
const lineBreak = "_35sl4xnjiq";
const newlineIndicator = "_35sncfcjuy";

export { lineBreak, newlineIndicator, whitespace };
import "./util.map-words-to-elements.style.linaria.module.css";
//# sourceMappingURL=util.map-words-to-elements.style.js.map
